import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";
import i18n from "@/core/plugins/i18n";
import helpers from "@/core/helpers/lists.js"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          pageTitle: "dashboard",
          breadcrumbs: ["dashboard"],
        },
      },
      {
        path: "/company-management",
        name: "companyManagement",
        component: () => import("@/views/company/index.vue"),
        meta: {
          pageTitle: "companyManagement",
          breadcrumbs: ["companyManagement"],
          authName: 'company',
          children: 'list'
        },
      },
      {
        path: "/equipmentinfos",
        name: "equipmentInfos",
        component: () => import("@/views/equipment/index.vue"),
        meta: {
          pageTitle: "equipments",
          breadcrumbs: ["equipmentInfo"],
          authName: 'equipment',
          children: 'list'
        },
      },
      {
        path: "/equipmentinfos/process/:id?",
        name: "processEquipment",
        component: () => import("@/views/equipment/addEdit.vue"),
        meta: {
          pageTitle: "equipmentDetail",
          authName: 'equipment',
          children: 'list'
        },
      },
      {
        path: "/part-photo-areas",
        name: "partPhotoAreas",
        component: () => import("@/views/partPhotoAreas/index.vue"),
        meta: {
          pageTitle: "partPhotoAreas",
          breadcrumbs: ["partPhotoAreas"],
          authName: 'partPhotoAreas',
          children: 'list'
        },
      },
      {
        path: "/locationinfos/:autoSearch?",
        name: "locationInfos",
        component: () => import("@/views/location/index.vue"),
        meta: {
          pageTitle: "locations",
          breadcrumbs: ["locationInfo"],
          authName: 'location',
          children: 'list'
        },
      },
      {
        path: "/draft-contract",
        name: "draftContract",
        component: () => import("@/views/draftContract/index.vue"),
        meta: {
          pageTitle: "draftContract",
          breadcrumbs: ["contract"],
          authName: 'draftContract',
          children: 'list'
        },
      },
      {
        path: "/draft-contract-info/process/:id?",
        name: "processContract",
        component: () => import("@/views/draftContract/addEdit.vue"),
        meta: {
          pageTitle: "contractDetail",
          authName: 'draftContract',
          children: 'add'
        },
      },
      {
        path: "/userinfos",
        name: "userInfos",
        component: () => import("@/views/user/index.vue"),
        meta: {
          pageTitle: "users",
          breadcrumbs: ["users"],
          authName: 'user',
          children: 'list'
        },
        children: [
          {
            path: "/userInfos/active",
            name: "active",
            component: () => import("@/views/user/index.vue"),
            meta: {
              pageTitle: "activeUsers",
              authName: 'user',
              children: 'list'
            },
          },
          {
            path: "/userInfos/inactive",
            name: "inactive",
            component: () => import("@/views/user/index.vue"),
            meta: {
              pageTitle: "inactiveUsers",
              authName: 'user',
              children: 'list'
            },
          },
        ]
      },
      {
        path: "/deliveryinfos/:status?",
        name: "deliveryinfos",
        component: () => import("@/views/delivery/index.vue"),
        meta: {
          pageTitle: "deliveries",
          breadcrumbs: ["deliveries"],
          authName: 'deliveries',
          children: 'list'
        },
      },
      {
        path: "/deliveryInfos/process/:id",
        name: "processDelivery",
        component: () => import("@/views/delivery/addEdit.vue"),
        meta: {
          pageTitle: "deliveryDetail",
          authName: 'deliveries',
          children: 'list'
        },
      },
      {
        path: "/compensationClaims",
        name: "compensationClaims",
        component: () => import("@/views/delivery/compensationClaims.vue"),
        meta: {
          pageTitle: "compensationClaims",
          authName: 'deliveries',
          children: 'compensationClaims'
        },
      },
      {
        path: "/vehicleinfos/:autoSearch?/:status?",
        name: "vehicleInfos",
        component: () => import("@/views/vehicle/index.vue"),
        meta: {
          pageTitle: "vehicles",
          breadcrumbs: ["vehicleInfo"],
          authName: 'vehicle',
          children: 'list'
        },
      },
      {
        path: "/vehicledetail/:id",
        name: "vehicleDetail",
        component: () => import("@/views/vehicle/detail.vue"),
        meta: {
          pageTitle: "vehicleDetail",
          breadcrumbs: ["vehicleDetail"],
          authName: 'vehicle',
          children: 'list'
        },
      },
      {
        path: "/vehicle-fleet-recruitment",
        name: "wheelsysFleetRecruitment",
        component: () => import("@/views/vehicle/FleetRecruitment.vue"),
        meta: {
          pageTitle: "wheelsysFleetRecruitment",
          authName: 'vehicle',
          children: 'wheelsys_fleet_recruitment'
        },
      },
      {
        path: "/vehicle-compare",
        name: "vehicleCompare",
        component: () => import("@/views/vehicle/compare.vue"),
        meta: {
          pageTitle: "vehicleCompare",
          authName: 'vehicle',
          children: 'compare'
        },
      },
      {
        path: "/collections",
        name: "collections",
        component: () => import("@/views/collections/index.vue"),
        meta: {
          pageTitle: "collections",
          breadcrumbs: ["collections"],
          authName: 'collections',
          children: 'list'
        },
      },
      {
        path: "/vehicle-fleet-recruitment",
        name: "wheelsysFleetRecruitment",
        component: () => import("@/views/vehicle/FleetRecruitment.vue"),
        meta: {
          pageTitle: "wheelsysFleetRecruitment",
          authName: 'vehicle',
          children: 'wheelsys_fleet_recruitment'
        },
      },
      {
        path: "/hgs/transitions",
        name: "hgsTransitions",
        component: () => import("@/views/hgs/index.vue"),
        meta: {
          pageTitle: "hgsTransitions",
          breadcrumbs: ["hgsTransitions"],
          authName: 'vehicle',
          children: 'rentsys_hgs'
        },
      },
      {
        path: "/hgs/differences",
        name: "hgsDifferences",
        component: () => import("@/views/hgs/differences.vue"),
        meta: {
          pageTitle: "hgsDifferences",
          breadcrumbs: ["hgsDifferences"],
          authName: 'vehicle',
          children: 'rentsys_hgs'
        },
      },
      {
        path: "/hgs/differences-wheelsys",
        name: "hgsDifferencesWheelsys",
        component: () => import("@/views/hgs/differences-wheelsys.vue"),
        meta: {
          pageTitle: "hgsDifferencesWheelsys",
          breadcrumbs: ["hgsDifferencesWheelsys"],
          authName: 'vehicle',
          children: 'rentsys_hgs'
        },
      },
      {
        path: "/washing",
        name: "washing",
        component: () => import("@/views/washing/index.vue"),
        meta: {
          pageTitle: "washing",
          breadcrumbs: ["washing"],
          authName: 'washing',
          children: 'list'
        },
      },
      {
        path: "/washing/category",
        name: "washingCategory",
        component: () => import("@/views/washing/category.vue"),
        meta: {
          pageTitle: "washingCategory",
          breadcrumbs: ["washingCategory"],
          authName: 'washing',
          children: 'washingCategory_list'
        },
      },
      {
        path: "/washing/process/:id",
        name: "washingDetail",
        component: () => import("@/views/washing/addEdit.vue"),
        meta: {
          pageTitle: "washingDetail",
          breadcrumbs: ["washingDetail"],
          authName: 'washing',
          children: 'list'
        },
      },
      {
        path: "/washing-cancel-options",
        name: "washingCancelOptions",
        component: () => import("@/views/washing/optionsCancel.vue"),
        meta: {
          pageTitle: "washingCancelOptions",
          breadcrumbs: ["washingCancelOptions"],
          authName: 'washing',
          children: 'washingCancelOptions_list'
        },
      },
      {
        path: "/delivery-contract-infos",
        name: "deliveryContractInfo",
        component: () => import("@/views/deliveryContract/index.vue"),
        meta: {
          pageTitle: "contracts",
          breadcrumbs: ["deliveryContractInfo"],
          authName: 'deliveries',
          children: 'deliveryContract_list'
        },
      },
      {
        path: "/branch-mode-settings",
        name: "branchMode",
        component: () => import("@/views/branchMode/index.vue"),
        meta: {
          pageTitle: "branchMode",
          breadcrumbs: ["branchMode"],
          authName: 'branchModeSettings',
          children: 'list'
        },
      },
      {
        path: "/authority-groups",
        name: "authorityGroups",
        component: () => import("@/views/authorityGroups/index.vue"),
        meta: {
          pageTitle: "authorityGroups",
          breadcrumbs: ["authorityGroups"],
          authName: 'authorityGroups',
          children: 'list'
        },
      },
      {
        path: "/file-management",
        name: "fileManagement",
        component: () => import("@/views/fileManagement/index.vue"),
        meta: {
          pageTitle: "fileManagement",
          breadcrumbs: ["fileManagement"],
          authName: 'fileManagement',
          children: 'list'
        },
      },
      {
        path: "/car-park-census",
        name: "carParkCensus",
        component: () => import("@/views/carParkCensus/index.vue"),
        meta: {
          pageTitle: "carParkCensus",
          breadcrumbs: ["carParkCensus"],
          authName: 'carParkCensus',
          children: 'list'
        },
      },
      {
        path: "/car-park-census-detail/:id",
        name: "carParkCensusDetail",
        component: () => import("@/views/carParkCensus/detail.vue"),
        meta: {
          pageTitle: "carParkCensusDetail",
          breadcrumbs: ["carParkCensus"],
          authName: 'carParkCensus',
          children: 'list'
        },
      },
      {
        path: "/crafted/pages/profile",
        name: "profile",
        component: () => import("@/components/page-layouts/Profile.vue"),
        meta: {
          breadcrumbs: ["Pages", "Profile"],
        },
        children: [
          {
            path: "overview",
            name: "profile-overview",
            component: () =>
              import("@/views/crafted/pages/profile/Overview.vue"),
            meta: {
              pageTitle: "Overview",
            },
          },
          {
            path: "password-reset",
            name: "profile-password-reset",
            component: () =>
              import("@/views/crafted/pages/profile/PasswordReset.vue"),
            meta: {
              pageTitle: "Password Reset",
            },
          },
          {
            path: "projects",
            name: "profile-projects",
            component: () =>
              import("@/views/crafted/pages/profile/Projects.vue"),
            meta: {
              pageTitle: "Projects",
            },
          },
          {
            path: "campaigns",
            name: "profile-campaigns",
            component: () =>
              import("@/views/crafted/pages/profile/Campaigns.vue"),
            meta: {
              pageTitle: "Campaigns",
            },
          },
          {
            path: "documents",
            name: "profile-documents",
            component: () =>
              import("@/views/crafted/pages/profile/Documents.vue"),
            meta: {
              pageTitle: "Documents",
            },
          },
          {
            path: "connections",
            name: "profile-connections",
            component: () =>
              import("@/views/crafted/pages/profile/Connections.vue"),
            meta: {
              pageTitle: "Connections",
            },
          },
          {
            path: "activity",
            name: "profile-activity",
            component: () =>
              import("@/views/crafted/pages/profile/Activity.vue"),
            meta: {
              pageTitle: "Activity",
            },
          },
        ],
      },
      {
        path: "/crafted/account",
        name: "account",
        component: () => import("@/views/crafted/account/Account.vue"),
        meta: {
          breadcrumbs: ["Crafted", "Account"],
        },
        children: [
          {
            path: "overview",
            name: "account-overview",
            component: () => import("@/views/crafted/account/Overview.vue"),
            meta: {
              pageTitle: "Overview",
            },
          },
          {
            path: "settings",
            name: "account-settings",
            component: () => import("@/views/crafted/account/Settings.vue"),
            meta: {
              pageTitle: "Settings",
            },
          },
        ],
      },
      {
        path: "/damageinfos",
        name: "damageInfo",
        component: () => import("@/views/damage/index.vue"),
        meta: {
          pageTitle: "damageRecords",
          breadcrumbs: ["damage"],
          authName: 'damage',
          children: 'list'
        },
      },
      {
        path: "/damagedetail/:id",
        name: "damageDetail",
        component: () => import("@/views/damage/detail.vue"),
        meta: {
          pageTitle: "damageDetail",
          breadcrumbs: ["damageDetail"],
          authName: 'damage',
          children: 'list'
        },
      },
      {
        path: "/delivery-cancel-options",
        name: "deliveryCancelOptions",
        component: () => import("@/views/delivery/optionsCancel.vue"),
        meta: {
          pageTitle: "deliveryCancelOptions",
          breadcrumbs: ["deliveryCancelOptions"],
          authName: 'deliveries',
          children: 'deliveryCancelOptions_list'
        },
      },
      {
        path: "/delivery-return-types",
        name: "deliveryReturnTypes",
        component: () => import("@/views/delivery/returnTypes.vue"),
        meta: {
          pageTitle: "deliveryReturnTypes",
          breadcrumbs: ["deliveryReturnTypes"],
          authName: 'deliveries',
          children: 'deliveryReturnTypes_list'
        },
      },
      {
        path: "/service-types",
        name: "serviceTypes",
        component: () => import("@/views/service/types.vue"),
        meta: {
          pageTitle: "serviceTypes",
          breadcrumbs: ["serviceTypes"],
          authName: 'service',
          children: 'serviceTypes_list'
        },
      },
      {
        path: "/services",
        name: "services",
        component: () => import("@/views/service/index.vue"),
        meta: {
          pageTitle: "service_records",
          breadcrumbs: ["service_records"],
          authName: 'service',
          children: 'list'
        },
      },
      {
        path: "/service-cancel-options",
        name: "serviceCancelOptions",
        component: () => import("@/views/service/optionsCancel.vue"),
        meta: {
          pageTitle: "serviceCancelOptions",
          breadcrumbs: ["serviceCancelOptions"],
          authName: 'service',
          children: 'serviceCancelOptions_list'
        },
      },

      {
        path: "/serviceInfos/process/:id",
        name: "processService",
        component: () => import("@/views/service/addEdit.vue"),
        meta: {
          pageTitle: "serviceDetail",
          breadcrumbs: ["serviceDetail"],
          authName: 'service',
          children: 'list'
        },
      },

      {
        path: "/delivery-types",
        name: "deliveryTypes",
        component: () => import("@/views/delivery/deliveryTypes.vue"),
        meta: {
          pageTitle: "deliveryTypes",
          breadcrumbs: ["deliveryTypes"],
          authName: 'deliveries',
          children: 'deliveryTypes_list'
        },
      },
      {
        path: "/findeks",
        name: "findeks",
        component: () => import("@/views/findeks/index.vue"),
        meta: {
          pageTitle: "findeks",
          breadcrumbs: ["findeks"],
          authName: 'findeks',
          children: 'list'
        },
      },
      {
        path: "/damage-types",
        name: "damageTypes",
        component: () => import("@/views/damage/damageTypes.vue"),
        meta: {
          pageTitle: "damageTypes",
          breadcrumbs: ["damageTypes"],
          authName: 'damage',
          children: 'damageTypes_list'
        },
      },
      {
        path: "/accident-report-type",
        name: "accidentReportType",
        component: () => import("@/views/damage/accidentReportType.vue"),
        meta: {
          pageTitle: "accidentReportType",
          breadcrumbs: ["accidentReportType"],
          authName: 'damage',
          children: 'accidentReportType_list'
        },
      },
      {
        path: "/dealer",
        name: "dealer",
        component: () => import("@/views/dealer/index.vue"),
        meta: {
          pageTitle: "dealer",
          breadcrumbs: ["dealer"],
          authName: 'dealer',
          children: 'list'
        },
      },
      {
        path: "/devices",
        name: "devices",
        component: () => import("@/views/devices/index.vue"),
        meta: {
          pageTitle: "devices",
          breadcrumbs: ["devices"],
          authName: 'devices',
          children: 'list'
        },
      },
      {
        path: "/announcements",
        name: "announcements",
        component: () => import("@/views/announcements/index.vue"),
        meta: {
          pageTitle: "announcements",
          breadcrumbs: ["announcements"],
          authName: 'announcements',
          children: 'list'
        },
      },
      {
        path: "/announcements-info/:id?",
        name: "announcementsInfo",
        component: () => import("@/views/announcements/addEdit.vue"),
        meta: {
          pageTitle: "announcementsInfo",
          breadcrumbs: ["announcementsInfo"],
          authName: 'announcements',
          children: 'list'
        },
      },
      {
        path: "/alerts/washing",
        name: "washingAlert",
        component: () => import("@/views/alert/washing.vue"),
        meta: {
          pageTitle: "alerts",
          breadcrumbs: ["alerts"],
          authName: 'alerts',
          children: 'list'
        },
      },
      {
        path: "/alerts/delivery",
        name: "deliveryAlert",
        component: () => import("@/views/alert/delivery.vue"),
        meta: {
          pageTitle: "alerts",
          breadcrumbs: ["alerts"],
          authName: 'alerts',
          children: 'list'
        },
      },
      {
        path: "/alerts/vehicle",
        name: "vehicleAlert",
        component: () => import("@/views/alert/vehicle.vue"),
        meta: {
          pageTitle: "alerts",
          breadcrumbs: ["alerts"],
          authName: 'alerts',
          children: 'list'
        },
      },
      {
        path: "/subscription-plans",
        name: "subscription-plans",
        component: () => import("@/views/subscription/index.vue"),
        meta: {
          pageTitle: "subscription",
          breadcrumbs: ["subscription"],
          authName: 'subscription',
          children: 'list'
        },
      },
      {
        path: "/subscription-overview",
        name: "subscription-overview",
        component: () => import("@/views/subscription/overview.vue"),
        meta: {
          pageTitle: "subscription",
          breadcrumbs: ["subscription"],
          authName: 'subscription',
          children: 'list'
        },
      },
      {
        path: "/subscription-invoice",
        name: "subscription-invoice",
        component: () => import("@/views/subscription/invoice.vue"),
        meta: {
          pageTitle: "subscription",
          breadcrumbs: ["subscription"],
          authName: 'subscription',
          children: 'list'
        },
      },
      {
        path: "/extras",
        name: "extras",
        component: () => import("@/views/extras/index.vue"),
        meta: {
          pageTitle: "extras",
          breadcrumbs: ["extras"],
          authName: 'extras',
          children: 'list'
        },
      },
      {
        path: "/apps/customers/getting-started",
        name: "apps-customers-getting-started",
        component: () => import("@/views/apps/customers/GettingStarted.vue"),
        meta: {
          pageTitle: "Getting Started",
          breadcrumbs: ["Apps", "Customers"],
        },
      },
      {
        path: "/apps/customers/customers-listing",
        name: "apps-customers-listing",
        component: () => import("@/views/apps/customers/CustomersListing.vue"),
        meta: {
          pageTitle: "Customers Listing",
          breadcrumbs: ["Apps", "Customers"],
        },
      },
      {
        path: "/apps/customers/customer-details",
        name: "apps-customers-details",
        component: () => import("@/views/apps/customers/CustomerDetails.vue"),
        meta: {
          pageTitle: "Customers Details",
          breadcrumbs: ["Apps", "Customers"],
        },
      },
      {
        path: "/apps/subscriptions/getting-started",
        name: "apps-subscriptions-getting-started",
        component: () =>
          import("@/views/apps/subscriptions/GettingStarted.vue"),
        meta: {
          pageTitle: "Getting Started",
          breadcrumbs: ["Apps", "Subscriptions"],
        },
      },
      {
        path: "/apps/subscriptions/subscription-list",
        name: "apps-subscriptions-subscription-list",
        component: () =>
          import("@/views/apps/subscriptions/SubscriptionList.vue"),
        meta: {
          pageTitle: "Getting Started",
          breadcrumbs: ["Apps", "Subscriptions"],
        },
      },
      {
        path: "/apps/subscriptions/add-subscription",
        name: "apps-subscriptions-add-subscription",
        component: () =>
          import("@/views/apps/subscriptions/AddSubscription.vue"),
        meta: {
          pageTitle: "Add Subscription",
          breadcrumbs: ["Apps", "Subscriptions"],
        },
      },
      {
        path: "/apps/subscriptions/view-subscription",
        name: "apps-subscriptions-view-subscription",
        component: () =>
          import("@/views/apps/subscriptions/ViewSubscription.vue"),
        meta: {
          pageTitle: "View Subscription",
          breadcrumbs: ["Apps", "Subscriptions"],
        },
      },
      {
        path: "/apps/calendar",
        name: "apps-calendar",
        component: () => import("@/views/apps/Calendar.vue"),
        meta: {
          pageTitle: "Calendar",
          breadcrumbs: ["Apps"],
        },
      },
      {
        path: "/apps/chat/private-chat",
        name: "apps-private-chat",
        component: () => import("@/views/apps/chat/Chat.vue"),
        meta: {
          pageTitle: "Private Chat",
          breadcrumbs: ["Apps", "Chat"],
        },
      },
      {
        path: "/apps/chat/group-chat",
        name: "apps-group-chat",
        component: () => import("@/views/apps/chat/Chat.vue"),
        meta: {
          pageTitle: "Group Chat",
          breadcrumbs: ["Apps", "Chat"],
        },
      },
      {
        path: "/apps/chat/drawer-chat",
        name: "apps-drawer-chat",
        component: () => import("@/views/apps/chat/DrawerChat.vue"),
        meta: {
          pageTitle: "Drawer Chat",
          breadcrumbs: ["Apps", "Chat"],
        },
      },
      {
        path: "/crafted/modals/general/invite-friends",
        name: "modals-general-invite-friends",
        component: () =>
          import("@/views/crafted/modals/general/InviteFriends.vue"),
        meta: {
          pageTitle: "Invite Friends",
          breadcrumbs: ["Crafted", "Modals", "General"],
        },
      },
      {
        path: "/crafted/modals/general/view-user",
        name: "modals-general-view-user",
        component: () => import("@/views/crafted/modals/general/ViewUsers.vue"),
        meta: {
          pageTitle: "View User",
          breadcrumbs: ["Crafted", "Modals", "General"],
        },
      },
      {
        path: "/crafted/modals/general/upgrade-plan",
        name: "modals-general-upgrade-plan",
        component: () =>
          import("@/views/crafted/modals/general/UpgradePlan.vue"),
        meta: {
          pageTitle: "Upgrade Plan",
          breadcrumbs: ["Crafted", "Modals", "General"],
        },
      },
      {
        path: "/crafted/modals/general/share-and-earn",
        name: "modals-general-share-and-earn",
        component: () =>
          import("@/views/crafted/modals/general/ShareAndEarn.vue"),
        meta: {
          pageTitle: "Share And Earn",
          breadcrumbs: ["Crafted", "Modals", "General"],
        },
      },
      {
        path: "/crafted/modals/forms/new-target",
        name: "modals-forms-new-target",
        component: () => import("@/views/crafted/modals/forms/NewTarget.vue"),
        meta: {
          pageTitle: "New Target",
          breadcrumbs: ["Crafted", "Modals", "Forms"],
        },
      },
      {
        path: "/crafted/modals/forms/new-card",
        name: "modals-forms-new-card",
        component: () => import("@/views/crafted/modals/forms/NewCard.vue"),
        meta: {
          pageTitle: "New Card",
          breadcrumbs: ["Crafted", "Modals", "Forms"],
        },
      },
      {
        path: "/crafted/modals/forms/new-address",
        name: "modals-forms-new-address",
        component: () => import("@/views/crafted/modals/forms/NewAddress.vue"),
        meta: {
          pageTitle: "New Address",
          breadcrumbs: ["Crafted", "Modals", "Forms"],
        },
      },
      {
        path: "/crafted/modals/forms/create-api-key",
        name: "modals-forms-create-api-key",
        component: () =>
          import("@/views/crafted/modals/forms/CreateApiKey.vue"),
        meta: {
          pageTitle: "Create Api Key",
          breadcrumbs: ["Crafted", "Modals", "Forms"],
        },
      },
      {
        path: "/crafted/modals/wizards/two-factor-auth",
        name: "modals-wizards-two-factor-auth",
        component: () =>
          import("@/views/crafted/modals/wizards/TwoFactorAuth.vue"),
        meta: {
          pageTitle: "Two Factory Auth",
          breadcrumbs: ["Crafted", "Modals", "Wizards"],
        },
      },
      {
        path: "/crafted/modals/wizards/create-app",
        name: "modals-wizards-create-app",
        component: () => import("@/views/crafted/modals/wizards/CreateApp.vue"),
        meta: {
          pageTitle: "Create App",
          breadcrumbs: ["Crafted", "Modals", "Wizards"],
        },
      },
      {
        path: "/crafted/modals/wizards/create-account",
        name: "modals-wizards-create-account",
        component: () =>
          import("@/views/crafted/modals/wizards/CreateAccount.vue"),
        meta: {
          pageTitle: "Create Account",
          breadcrumbs: ["Crafted", "Modals", "Wizards"],
        },
      },
      {
        path: "/crafted/widgets/lists",
        name: "widgets-list",
        component: () => import("@/views/crafted/widgets/Lists.vue"),
        meta: {
          pageTitle: "Lists",
          breadcrumbs: ["Crafted", "Widgets"],
        },
      },
      {
        path: "/crafted/widgets/statistics",
        name: "widgets-statistics",
        component: () => import("@/views/crafted/widgets/Statistics.vue"),
        meta: {
          pageTitle: "Statistics",
          breadcrumbs: ["Crafted", "Widgets"],
        },
      },
      {
        path: "/crafted/widgets/charts",
        name: "widgets-charts",
        component: () => import("@/views/crafted/widgets/Charts.vue"),
        meta: {
          pageTitle: "Charts",
          breadcrumbs: ["Crafted", "Widgets"],
        },
      },
      {
        path: "/crafted/widgets/mixed",
        name: "widgets-mixed",
        component: () => import("@/views/crafted/widgets/Mixed.vue"),
        meta: {
          pageTitle: "Mixed",
          breadcrumbs: ["Crafted", "Widgets"],
        },
      },
      {
        path: "/crafted/widgets/tables",
        name: "widgets-tables",
        component: () => import("@/views/crafted/widgets/Tables.vue"),
        meta: {
          pageTitle: "Tables",
          breadcrumbs: ["Crafted", "Widgets"],
        },
      },
      {
        path: "/crafted/widgets/feeds",
        name: "widgets-feeds",
        component: () => import("@/views/crafted/widgets/Feeds.vue"),
        meta: {
          pageTitle: "Feeds",
          breadcrumbs: ["Crafted", "Widgets"],
        },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () => import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
        meta: {
          pageTitle: "signIn",
        },
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () => import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
        meta: {
          pageTitle: "signUp",
        },
      },
      /*{
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
        meta: {
          pageTitle: "Password reset",
        },
      }, */
    ],
  },
  {
    path: "/delivery-detail/:language?/:id",
    component: () => import("@/views/delivery/externalDeliveryDetail.vue"),
    meta: {
      pageTitle: "deliveryDetail",
    },
  },
  {
    path: "/agreement/:token",
    name: "agreement",
    component: () => import("@/views/deliveryContract/signedUrl.vue"),
    meta: {
      pageTitle: "pdf_contract",
    },
  },
  {
    path: "/",
    component: () => import("@/layouts/SystemLayout.vue"),
    children: [
      {
        // the 404 route, when none of the above matches
        path: "/403",
        name: "403",
        component: () => import("@/views/crafted/authentication/Error403.vue"),
        meta: {
          pageTitle: "Error 403",
        },
      },
      {
        // the 404 route, when none of the above matches
        path: "/404",
        name: "404",
        component: () => import("@/views/crafted/authentication/Error404.vue"),
        meta: {
          pageTitle: "Error 404",
        },
      },
      {
        path: "/500",
        name: "500",
        component: () => import("@/views/crafted/authentication/Error500.vue"),
        meta: {
          pageTitle: "Error 500",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

/* router.beforeEach((to, from, next) => {
  // current page view title
  document.title = `${t(to.meta.pageTitle)} - ${import.meta.env.VITE_NAME}`;

  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // verify auth token before each page change
  store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });

  if(to.meta.authName && to.meta.children) {
        helpers.authControl(to.meta.authName, to.meta.children) ? next() : next('/404')
  } else next();
  
  // before page access check if page requires authentication
  if (to.meta.middleware == "auth") {
    if (store.getters.isUserAuthenticated) {
      next();
    } else {
      // ? if not authenticated redirect to sign-in page
      router.push({ path: "/sign-in", query: { to: to.path } });
    }
  } else {
    next();
  }

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
}); */

router.beforeEach(async (to, from, next) => {
  // Sayfa başlığını ayarlama - i18n.global.t kullanarak güncel dil desteği
  document.title = `${i18n.global.t(to.meta.pageTitle)} - ${import.meta.env.VITE_NAME}`;

  // Yapılandırmayı sıfırlama
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // Kimlik doğrulama kontrolü
  store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });

  if (to.meta.authName && to.meta.children) {
    if (to.meta.authName !== 'subscription' && !(await helpers.moduleControl(to.meta.authName))) return next('/403');

    if (!helpers.authControl(to.meta.authName, to.meta.children)) {
      return next('/403'); // Eğer yetkisizse doğrudan "/404" sayfasına yönlendirin
    }
  }

  // Eğer oturum açma gerekiyorsa kontrol edin
  if (to.meta.middleware === "auth") {
    if (!store.getters.isUserAuthenticated) {
      // Eğer kimlik doğrulaması yoksa giriş sayfasına yönlendirin
      return next({ path: "/sign-in", query: { to: to.path } });
    }
  }

  // Sayfa geçişlerinde yukarıya kaydırma
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  // Yalnızca bir kez `next()` çağrılır
  next();
});


export default router;
